import React from 'react';

import Form from '~/components/Forms/Form';
import styled from 'styled-components';
import EmailNotificationsForm from './components/EmailNotificationsForm';
import { NotificationSettings } from '~/graphql/types';
import { asEmailNotificationsFormData } from './util';
import FormSaveBar from '../SaveBar/FormSaveBar';
import DetailsBlock from '../DetailsBlock';

export type EmailNotificationsFormData = {
  dailyDigest: boolean;

  taskNewUnassigned: boolean;
  taskGotAssignedToMe: boolean;
  taskGotAssignedToMyOffices: boolean;

  valueReportAppNewContact: boolean;
  valueReportAppForContactAssignedToMe: boolean;
  valueReportAppForContactAssignedToMyOffices: boolean;

  appBBWaardecheckNewContact: boolean;
  appBBWaardecheckForContactAssignedToMe: boolean;
  appBBWaardecheckForContactAssignedToMyOffices: boolean;

  appVBOWaardecheckNewContact: boolean;
  appVBOWaardecheckForContactAssignedToMe: boolean;
  appVBOWaardecheckForContactAssignedToMyOffices: boolean;

  contactGotAssignedToMe: boolean;
  contactGotAssignedToMyOffices: boolean;
};

export type Props = {
  dataTestId?: string;
  onFormSubmit: (newFormData: EmailNotificationsFormData) => void;
  notificationSettings: NotificationSettings;
};

const EmailNotificationsBlock: React.FC<Props> = ({
  dataTestId,
  onFormSubmit,
  notificationSettings,
  ...rest
}) => (
  <DetailsBlock>
    <Form
      onSubmit={onFormSubmit}
      initialValues={asEmailNotificationsFormData(notificationSettings)}
      data-testid={dataTestId}
    >
      {({ handleSubmit }) => (
        <StyledForm
          id="email-notifications-form"
          onSubmit={handleSubmit}
          data-testid="email-notifications-form"
          {...rest}
        >
          <EmailNotificationsForm />
          <FormSaveBar inBlockComponent />
        </StyledForm>
      )}
    </Form>
  </DetailsBlock>
);

export default EmailNotificationsBlock;

const StyledForm = styled.form<{}>`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;
